import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import itPortalService from "../services/itPortalService";
import SideBar from "../components/SideBar";

export default function ITPortalLogin() {
  const [otpSent, setOtpSent] = useState(false);
  const [otp, setOtp] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const [successMsg, setSuccessMsg] = useState("");
  const navigate = useNavigate();

  const handleSendOtp = async () => {
    setIsLoading(true);
    setError("");
    setSuccessMsg("");
    try {
      const response = await itPortalService.sendOtp();
      if (response.status === 200 || response.status === 201) {
        setOtpSent(true);
        setSuccessMsg(response.data?.message || "OTP sent to your email.");
      }
    } catch (err) {
      setError(err.response?.data?.message || "Failed to send OTP.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleVerifyOtp = async (e) => {
    e.preventDefault();
    if (!otp) {
      setError("Please enter the OTP.");
      return;
    }

    setIsLoading(true);
    setError("");
    try {
      const response = await itPortalService.verifyOtp(otp);
      if (response.status === 200 || response.status === 201) {
        // Assume access is granted, redirect to IT Portal Dashboard
        navigate("/it-portal/dashboard");
      }
    } catch (err) {
      setError(err.response?.data?.message || "Invalid OTP.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div style={{ display: 'flex', minHeight: '100vh', backgroundColor: '#F8F9FA' }}>
      <SideBar />
      <div style={{ flex: 1, padding: '20px' }}>
        <div style={{ maxWidth: "500px", margin: "40px auto", padding: "30px", background: "#fff", borderRadius: "8px", boxShadow: "0 2px 10px rgba(0,0,0,0.1)" }}>
          <h2 style={{ textAlign: "center", marginBottom: "20px", color: "#19224D" }}>IT Portal Security</h2>
          
          <p style={{ textAlign: "center", color: "#555", marginBottom: "30px" }}>
            The IT Portal requires a secondary verification step to access critical system configurations.
          </p>

          {error && <div style={{ color: "red", marginBottom: "15px", textAlign: "center" }}>{error}</div>}
          {successMsg && <div style={{ color: "green", marginBottom: "15px", textAlign: "center" }}>{successMsg}</div>}

          {!otpSent ? (
            <div style={{ textAlign: "center" }}>
              <button 
                onClick={handleSendOtp} 
                disabled={isLoading}
                style={{
                  background: "#19224D",
                  color: "#fff",
                  padding: "10px 20px",
                  border: "none",
                  borderRadius: "5px",
                  cursor: isLoading ? "not-allowed" : "pointer",
                  fontSize: "16px"
                }}
              >
                {isLoading ? "Sending..." : "Request OTP to Email"}
              </button>
            </div>
          ) : (
            <form onSubmit={handleVerifyOtp} style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
              <div style={{ width: "100%", marginBottom: "15px" }}>
                <input
                  type="text"
                  placeholder="Enter OTP"
                  value={otp}
                  onChange={(e) => setOtp(e.target.value)}
                  style={{
                    width: "100%",
                    padding: "10px",
                    border: "1px solid #ddd",
                    borderRadius: "5px",
                    fontSize: "16px",
                    textAlign: "center"
                  }}
                  required
                 maxLength={255} />
              </div>
              <button 
                type="submit" 
                disabled={isLoading}
                style={{
                  background: "#19224D",
                  color: "#fff",
                  padding: "10px 20px",
                  border: "none",
                  borderRadius: "5px",
                  cursor: isLoading ? "not-allowed" : "pointer",
                  fontSize: "16px",
                  width: "100%"
                }}
              >
                {isLoading ? "Verifying..." : "Verify & Access"}
              </button>
              
              <button 
                type="button" 
                onClick={handleSendOtp}
                disabled={isLoading}
                style={{
                  background: "transparent",
                  color: "#19224D",
                  padding: "10px 20px",
                  border: "none",
                  cursor: isLoading ? "not-allowed" : "pointer",
                  fontSize: "14px",
                  marginTop: "10px",
                  textDecoration: "underline"
                }}
              >
                Resend OTP
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
